import ApiClient from './ApiClient';

class Organizations extends ApiClient {
  constructor() {
    super('organizations', { accountScoped: true });
  }
}

export default new Organizations();
